import type {
	LiveSessionItem,
	SessionItem,
} from "@memorang/types/src/session/new-session";
import { Apps } from "types/apps";
import { aiopsSessionItems } from "./session-collection/ai-assessment";
import { aiEssentialsSessionItems } from "./session-collection/ai-essentials";
import { aswbSessionItems } from "./session-collection/aswb";
import { constructionSessionItems } from "./session-collection/construction";
import { databricksSessionItems } from "./session-collection/databricks";
import { financeSessionItems } from "./session-collection/finance";
import { healthcareSessionItems } from "./session-collection/healthcare";
import { mccqePart1PracticeItems } from "./session-collection/mcc";
import { mediquestSessionItems } from "./session-collection/mediquest";
import { officesyncSessionItems } from "./session-collection/officesync";
import { supervisionSessionItems } from "./session-collection/supervision";
import { techcoreSessionItems } from "./session-collection/techcore";
import { veterinarySessionItems } from "./session-collection/veterinary";

export {
	normalizeProethicaSessionResponse,
	getProethicaLiveCreateParams,
	proethicaLiveSessionConfig,
} from "./session-collection/proethica-live";
export { getProethicaTestCreateParams } from "./session-collection/proethica-test-session";

export type DemoExamsType =
	| "healthcare-1"
	| "construction-1"
	| "finance-1"
	| "officesync-1"
	| "techcore-1"
	| "mediquest-1"
	| "aswb-1"
	| "aswb-supervision-certification"
	| "ai-assessment"
	| "genai-engineer"
	| "ai-essentials"
	| "veterinary-medicine"
	| "mcc"
	| "proethica";
export type DemoExam = {
	id: DemoExamsType;
	name: string;
	icon: string;
	ailaName: string;
	agentId: string;
	showEMR?: boolean;
};

export const DEMO_EXAMS: DemoExam[] = [
	{
		id: "healthcare-1" as const,
		name: "HealthLink",
		ailaName: "Health Mentor",
		agentId: "571",
		icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/acme/healthcare.png?t=2024-11-15T05%3A16%3A47.701Z",
	},
	{
		id: "construction-1" as const,
		name: "BuildWise",
		ailaName: "HardHat Hero",
		agentId: "663",
		icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/acme/construction_new.png?t=2024-11-15T05%3A16%3A24.159Z",
	},
	{
		id: "finance-1" as const,
		name: "WealthPath",
		ailaName: "Fortune Wizard",
		agentId: "663",
		icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/acme/finanane.png?t=2024-11-15T05%3A16%3A35.504Z",
	},
	{
		id: "officesync-1" as const,
		name: "OfficeSync",
		ailaName: "Office Guru",
		agentId: "663",
		icon: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/demo/acme/office_sync.png",
	},
	{
		id: "techcore-1" as const,
		name: "TechCore",
		ailaName: "Tech Guru",
		agentId: "663",
		icon: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/demo/acme/tech_core.png",
	},
	{
		id: "mediquest-1" as const,
		name: "MediQuest",
		ailaName: "ClinIQ",
		agentId: "743",
		showEMR: true,
		icon: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/demo/acme/medical_1.png",
	},
	{
		id: "aswb-1" as const,
		name: "ASWB: Domestic Violence",
		ailaName: "ASWB Ally",
		agentId: "783",
		icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/ASWB/ASWB.png",
	},
	{
		id: "aswb-supervision-certification" as const,
		name: "ASWB: Supervision Certification",
		ailaName: "Roll Model",
		agentId: "785",
		icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/ASWB/ASWB.png",
	},
	{
		id: "ai-assessment" as const,
		name: "AI Assessment",
		ailaName: "GuardRail",
		agentId: "663",
		icon: "https://staging-services.memorang.com/storage/v1/object/public/memorang-assets/partners/acme/aiassess.png",
	},
	{
		id: "genai-engineer" as const,
		name: "GenAI Engineer",
		ailaName: "BrickWit",
		agentId: "663",
		icon: "https://staging-services.memorang.com/storage/v1/object/public/memorang-assets/partners/acme/data-bricks.jpeg",
	},
	{
		id: "ai-essentials" as const,
		name: "AI Essentials",
		ailaName: "Essie",
		agentId: "663",
		icon: "https://staging-services.memorang.com/storage/v1/object/public/memorang-assets/partners/acme/ai-essential-2.png",
	},
	{
		id: "veterinary-medicine" as const,
		name: "Veterinary Medicine",
		ailaName: "Rufus",
		agentId: "571",
		icon: "https://services.memorang.com/storage/v1/object/public/memorang-assets/demo/thieme/logo_1.jpg",
	},
	{
		id: "mcc" as const,
		name: "MCCQE Part I",
		ailaName: "Osler",
		agentId: "571",
		icon: "https://staging-services.memorang.com/storage/v1/object/public/memorang-assets/partners/acme/mcc.png",
	},
	{
		id: "proethica" as const,
		name: "Proethica",
		ailaName: "Ethica",
		agentId: "847",
		icon: "https://staging-services.memorang.com/storage/v1/object/public/memorang-assets/acme/icon_dark.png",
	},
];

export const isMockedData = true;

export const liveSessionEnabled = (examId?: string): boolean =>
	examId === Apps.Proethica;

//TODO: Organize this better
export const appLogo =
	"https://staging-services.memorang.com/storage/v1/object/public/memorang-assets/acme/icon_dark.png";
export const examName = "PRAXIS PROETHICA";
export const mockedAppName = "PRAXIS PROETHICA";
export const mockedTrademark = "PRAXIS PROETHICA";
export const itemsCount = {
	Reading: 1,
	Listening: 1,
	Speaking: 1,
	Writing: 1,
};

export const mockedExamIcon = {
	light:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/demo/pearson/idnqV2s7FX_1741758547755.svg",
	dark: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/demo/pearson/idnqV2s7FX_1741758481641.svg",
};

export const mockedReport = {
	sessionDate: new Date().toLocaleDateString("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric",
	}),
	cards: {
		distribution: {
			basic: 0,
			lowIntermediate: 1,
			highIntermediate: 1,
			advanced: 2,
			none: 0,
		},
		numPointsEarned: 8,
		numTotalPoints: 10,
		numTotalItems: 4,
		numTotalAnswered: 4,
		Reading: {
			numPointsEarned: 2,
			numTotalPoints: 2,
			numItems: 1,
		},
		Listening: {
			numPointsEarned: 2,
			numTotalPoints: 2,
			numItems: 1,
		},
		Speaking: {
			numPointsEarned: 2,
			numTotalPoints: 4,
			numItems: 1,
		},
		Writing: {
			numPointsEarned: 2,
			numTotalPoints: 2,
			numItems: 1,
		},
	},
	sessionSummaryAlertBody: (tags: string[]) =>
		`You practiced **${tags.join(", ")}**, demonstrating proficiency across these areas. Keep up the steady progress!`,
};

export const mockedLanding = {
	title: {
		prefix: "Praxis",
		decoratedText: "ProEthica",
		suffix: "",
	},
	marketText: {
		prefix: "ProEthica",
		suffix:
			"develops the critical skills educators need to navigate ethical challenges in today's classrooms.",
	},
	ctaLabel: "Continue with Praxis",
	valueProps: [
		{
			icon: "shield-check-outline",
			title: "Official App",
			subtitle: "Authored by the experts from the official Praxis team",
		},
		{
			icon: "briefcase-outline",
			title: "Real-World Scenarios",
			subtitle:
				"8 modules and embedded simulations focused on professional responsibilities",
		},
		{
			icon: "message-text-outline",
			title: "Detailed Feedback",
			subtitle:
				"Receive personalized, AI-powered feedback aligned to ProEthics principles and MCEE criteria",
		},
	],
	landingGraphics:
		"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/app-assets/mockup.png",
};

export const mockedHomeStats = {
	modulesCompleted: 3,
	itemsAnswered: 45,
	percentComplete: 64,
};

export const mockedDiagnosticStats = {
	"Reading & Listening": {
		numItems: 2,
	},
	"Speaking & Writing": {
		numItems: 2,
	},
};
// PRAXIS
export const praxisLogo = {
	light:
		"https://staging-services.memorang.com/storage/v1/object/public/memorang-assets/acme/icon_light.png",
	dark: "https://staging-services.memorang.com/storage/v1/object/public/memorang-assets/acme/icon_dark.png",
};

export const tagIconMap: Record<string, string> = {
	// Healthcare icons
	"Anatomy & Physiology": "medical-bag",
	"Patient Care": "hospital-box-outline",
	"Medical Terminology": "book-outline",
	"Healthcare Ethics": "shield-check-outline",

	// Construction icons
	"Safety Regulations": "shield-alert-outline",
	"Building Codes": "home-city-outline",
	"Project Management": "clipboard-check-outline",
	"Construction Equipment": "pier-crane",

	// Finance icons
	"Investment Analysis": "chart-line-variant",
	"Risk Management": "alert-circle-outline",
	"Financial Markets": "bank-outline",
	"Portfolio Management": "wallet-outline",

	// OfficeSync icons
	"Crisis Communication": "alert-octagon-outline",
	"Professional Listening": "ear-hearing",
	"Verbal Accountability": "account-voice",
	"Workplace Writing": "file-document-edit-outline",

	// TechCore icons
	"Incident Response": "shield-alert-outline",
	"Technical Listening": "headphones",
	"Technical Speaking": "microphone-outline",
	"IT Communication Writing": "keyboard-outline",

	// AI Assessment icons
	"AI Incident Response": "shield-alert-outline",
	"Stakeholder Communication": "account-group-outline",
	"AI Hallucination": "alert-octagon-outline",
	"AI Literacy": "book-open-page-variant",

	// AI Essentials icons
	"Prompt Engineering": "code-tags",
	"AI Hallucinations": "alert-octagon-outline",
	"Output Verification": "check-circle-outline",
	"Practical AI Use Cases": "lightbulb-outline",

	// Veterinary Medicine icons
	"Diagnostic Reasoning": "brain",
	"Rehabilitation Planning": "run",
	"Clinical Documentation": "file-document-outline",
	"Client Communication": "account-voice",

	History: "clock-outline",
	Exam: "clipboard-text-outline",
	Diagnosis: "stethoscope",
	Management: "cog-outline",
	Engagement: "handshake-outline",
	Assessment: "clipboard-check-outline",
	Intervention: "medical-bag",
	Advocacy: "bullhorn-outline",

	"Values and Ethics": "scale-balance",
	"Assessment and Planning": "clipboard-text-outline",
	"Intervention and Practice": "hand-heart",
	"Collaboration and Communication": "account-group",

	// MCCQE Part I — four demo skills (`mccDemoSkillTags` / `mockedTags.mcc`)
	Biostatistics: "chart-bell-curve",
	Medicine: "stethoscope",
	"Medical Ethics": "scale-balance",
	Psychiatry: "brain",

	// Proethica
	"Module 1": "school-outline",
	"Module 2": "school-outline",
	"Module 3": "school-outline",
	"Module 4": "school-outline",
	"Module 5": "school-outline",
	"Module 6": "school-outline",
	"Module 7": "school-outline",
	"Module 8": "school-outline",
};

export const mockedAppFavicon =
	"https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png";
export const mockedCompanyUrl = "https://www.ets.org";
export const mockedTosUrl = "https://www.ets.org/legal/terms.html";
export const mockedPrivacyUrl = "https://www.ets.org/legal/privacy.html";
export const mockedSupportEmail = "praxis@ets.org";

export const mockedAiAssistant = ({
	examName,
	examIcon,
}: {
	examName: string;
	examIcon: string;
}) => ({
	title: examName,
	alias: examName,
	icon: examIcon,
	showOriginalQuestion: false,
	initialMessage:
		"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
	initialAiMessage: {
		"en-US": "👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
		"ja-JP":
			"👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
		"zh-CN":
			"👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
	},
});

export const mockedTenantId = "605acad7-28a8-49eb-ab2f-c881bae4c81b";
export const mockedAgentId = "571";

export const mockedSessionItems: Record<DemoExamsType, SessionItem[]> = {
	"healthcare-1": healthcareSessionItems as unknown as SessionItem[],
	"construction-1": constructionSessionItems as unknown as SessionItem[],
	"finance-1": financeSessionItems as unknown as SessionItem[],
	"officesync-1": officesyncSessionItems as unknown as SessionItem[],
	"techcore-1": techcoreSessionItems as unknown as SessionItem[],
	"ai-assessment":
		aiopsSessionItems as unknown as SessionItem[] as unknown as SessionItem[],
	"mediquest-1": mediquestSessionItems as unknown as SessionItem[],
	"aswb-1": aswbSessionItems as unknown as SessionItem[],
	"aswb-supervision-certification":
		supervisionSessionItems as unknown as SessionItem[],
	"genai-engineer": databricksSessionItems as unknown as SessionItem[],
	"ai-essentials": aiEssentialsSessionItems as unknown as SessionItem[],
	"veterinary-medicine": veterinarySessionItems as unknown as SessionItem[],
	mcc: mccqePart1PracticeItems as unknown as SessionItem[],
	// ProEthica runs fully live (create-session), so it never reads this map.
	proethica: [],
};

type MockedSessionEnvelope = {
	id: number;
	numericId: number;
	status?: string;
	sessionTime?: number;
	startTime?: string;
	examBreak?: unknown;
	timeAllocation?: unknown;
	progressList?: unknown[];
	examName?: string;
	sessionSubType?: string;
	sessionItems: SessionItem[] | LiveSessionItem[];
};

const legacyEnvelope = (
	sessionItems: SessionItem[],
): MockedSessionEnvelope => ({
	id: 2798,
	numericId: 2798,
	status: "ACTIVE",
	sessionTime: 0,
	startTime: "2025-03-11T06:19:16.460Z",
	examBreak: "{}",
	progressList: [],
	sessionItems,
});

// Non-ProEthica demo exams return pre-built legacy items. ProEthica runs fully
// live (create-session), so it never reaches this mock path.
export const getMockedSessionResponse = (
	examType: DemoExamsType,
): MockedSessionEnvelope => legacyEnvelope(mockedSessionItems[examType]);
